import "./bootstrap"; // Must be first — clears stale exam data before React mounts
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App /> 
  // </React.StrictMode>
);
// Remove <React.StrictMode for double rendering in dev env>